import React, { useState } from "react";
import { Badge, Button, Card } from "react-bootstrap";
import { PencilSquare, Trash, ZoomIn, X } from "react-bootstrap-icons";
import "../../assets/css/vendors/HotelComponents/roomCard.css";

const RoomCard = ({ room, getHotelStatusClass, getAmenityIcon, onEdit, onDelete }) => {
  const [zoomedImg, setZoomedImg] = useState(null);

  const getAmenitiesList = () => {
    if (!room.amenities) return [];
    if (Array.isArray(room.amenities)) {
      return room.amenities;
    }
    if (typeof room.amenities === 'string') {
      return room.amenities.split(",").map(item => item.trim());
    }
    return [];
  };

  return (
    <>
      <Card className="rc-hotel-room-card">
        <div className="rc-hotel-room-card-header">
          <div className="rc-hotel-room-header-content">
            <div>
              <h4 className="rc-hotel-room-number">{room.room_number}</h4>
              <span className="rc-hotel-room-type">{room.room_type}</span>
            </div>
            <Badge className={`rc-hotel-room-status rc-${getHotelStatusClass(room.status)}`}>
              {room.status}
            </Badge>
          </div>
        </div>

        <div className="rc-hotel-room-card-content">
          {/* Room Images Strip */}
          {room.images && room.images.length > 0 && (
            <div className="rc-room-images-strip">
              {room.images.slice(0, 3).map((src, index) => (
                <div
                  key={index}
                  className="rc-room-img-wrap"
                  onClick={() => setZoomedImg(src)}
                  title="Click to zoom"
                >
                  <img
                    src={src}
                    alt={`Room ${room.room_number}`}
                    className="rc-room-img"
                  />
                  <div className="rc-room-img-overlay">
                    <ZoomIn size={14} color="white" />
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="rc-hotel-room-price">
            <span className="rc-hotel-price-label">Price:</span>
            <span className="rc-hotel-price-value">
              Rs. {(room.price || 0).toLocaleString()}
            </span>
          </div>

          <div className="rc-hotel-room-details">
            <div className="rc-hotel-detail-item">
              <span className="rc-hotel-detail-label">Capacity:</span>
              <span className="rc-hotel-detail-value">
                {room.capacity} Persons
              </span>
            </div>
            <div className="rc-hotel-detail-item">
              <span className="rc-hotel-detail-label">Floor:</span>
              <span className="rc-hotel-detail-value">{room.floor}</span>
            </div>
          </div>

          <div className="rc-hotel-room-amenities">
            <span className="rc-hotel-amenities-label">Amenities:</span>
            <div className="rc-hotel-amenities-list">
              {getAmenitiesList().map((amenity, index) => (
                <span key={index} className="rc-hotel-amenity-badge">
                  {getAmenityIcon(amenity)}
                  {amenity}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="rc-hotel-room-card-footer">
          <div className="rc-hotel-action-buttons">
            <Button 
              variant="outline-primary" 
              size="sm" 
              className="rc-hotel-edit-btn"
              onClick={onEdit}
            >
              <PencilSquare size={16} />
              Edit
            </Button>
            <Button 
              variant="outline-danger" 
              size="sm" 
              className="rc-hotel-delete-btn"
              onClick={onDelete}
            >
              <Trash size={16} />
              Delete
            </Button>
          </div>
        </div>
      </Card>

      {zoomedImg && (
        <div className="rc-zoom-backdrop" onClick={() => setZoomedImg(null)}>
          <div className="rc-zoom-box" onClick={(e) => e.stopPropagation()}>
            <button className="rc-zoom-close" onClick={() => setZoomedImg(null)}>
              <X size={22} />
            </button>
            <img src={zoomedImg} alt="Zoomed" className="rc-zoom-img" />
          </div>
        </div>
      )}
    </>
  );
};

export default RoomCard;